export default "__VITE_ASSET__CABIHP$X__"